export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '图标',
          dataIndex: 'icon',
        },
        {
          title: '地址',
          dataIndex: 'url',
        },
        {
          title: '代码',
          dataIndex: 'code',
        },
        {
          title: '类型',
          dataIndex: 'type',
          width: 120,
          customRender: text => (text == 1 ? '菜单' : '按钮/接口'),
        },
        {
          title: '操作',
          fixed: 'right',
          width: 150,
          dataIndex: 'action',
          slotName: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
